import { render, staticRenderFns } from "./CardItemCarrinho.vue?vue&type=template&id=654f74ba&scoped=true&"
import script from "./CardItemCarrinho.vue?vue&type=script&lang=js&"
export * from "./CardItemCarrinho.vue?vue&type=script&lang=js&"
import style0 from "./CardItemCarrinho.vue?vue&type=style&index=0&id=654f74ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f74ba",
  null
  
)

export default component.exports